import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks"
import { SetRegion  } from "../../../../../../redux/feature/RegionSlice"


export default function SelectRegion(props:any) {
  const name = useAppSelector(state => state.RegionSlice.name)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const dispatch = useAppDispatch()

 
    return(
        <div >
        <label className=' fw-bolder  fs-7 mb-0 '>Region</label>
          <select 
          style={{height:'auto',paddingTop:'0', paddingBottom:'0'}}
           disabled={name ===''}
           required
          className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example" value={name} 
          onChange={e => dispatch(SetRegion((e.target.value)))} >
                  { Type === 'Global' &&  <option value="Not applicable">Not applicable</option> }         
                  {  
                    props.info.map( (reg:any,i:any) =>
                    <option key={i} value={reg}>{reg}</option>
                    )
                  }

          </select>
      </div>
    )
  
}